class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.content = null;
    this.formInView = true;
    this.footerInView = false;
    this.formObserver = null;
    this.footerObserver = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.content = this.querySelector('.sticky-add-to-cart__content');

    if (!this.form || !this.content) return;

    // Réserve l'espace du sticky dans le flux pour éviter le changement de
    // hauteur du document quand le contenu passe en position: fixed. Sans cela,
    // le contenu sort du flux → la page raccourcit → le footer remonte dans le
    // viewport → le sticky se désactive → boucle infinie de clignotement.
    requestAnimationFrame(() => {
      this.style.minHeight = `${this.offsetHeight}px`;
      this.#initObservers();
    });
  }

  disconnectedCallback() {
    this.formObserver?.disconnect();
    this.footerObserver?.disconnect();
  }

  #initObservers() {
    // Ryyvo : on observe l'emplacement du bouton, pas tout le formulaire. La barre reste affichée
    // jusqu'à ce que l'emplacement soit entièrement visible, à la hauteur exacte de la barre (sa marge
    // du bas : 12 px sur mobile, 16 px sur ordinateur). Elle se pose alors à sa place sans saut.
    const margin = window.innerWidth > 750 ? 16 : 12;
    this.formObserver = new IntersectionObserver(
      ([entry]) => {
        this.formInView = entry.intersectionRatio >= 0.99;
        this.#updateDisplay();
      },
      { rootMargin: `0px 0px -${margin}px 0px`, threshold: [0, 0.99, 1] },
    );

    this.formObserver.observe(this);

    if (!this.footer) return;

    this.footerObserver = new IntersectionObserver(([entry]) => {
      this.footerInView = entry.isIntersecting;
      this.#updateDisplay();
    });

    this.footerObserver.observe(this.footer);
  }

  #updateDisplay() {
    const shouldBeActive = !this.formInView && !this.footerInView;
    const isActive = this.dataset.active === 'true';

    if (shouldBeActive === isActive) return;

    clearTimeout(this.closingTimeout);

    if (shouldBeActive) {
      delete this.dataset.closing;
      this.dataset.active = 'true';
      this.content.classList.add('color-scheme-1');
      return;
    }

    // Ryyvo : le bouton rejoint sa place instantanément. Avec l'animation de sortie, l'emplacement
    // restait vide pendant 300 ms. Elle ne sert plus qu'à l'arrivée sur le pied de page.
    if (this.formInView) {
      this.dataset.active = 'false';
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
      return;
    }

    this.dataset.active = 'false';
    this.dataset.closing = 'true';

    this.closingTimeout = setTimeout(() => {
      delete this.dataset.closing;
      this.content.classList.remove('color-scheme-1');
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
